interface SecurityPlaceholderProps {
  title: string;
}

export default function SecurityPlaceholderPage({ title }: SecurityPlaceholderProps) {
  return (
    <div className="p-6">
      <div className="max-w-md mx-auto mt-20 text-center">
        <h1 className="text-2xl font-bold text-secondary-900 dark:text-white mb-4">
          {title}
        </h1>
        <p className="text-secondary-600 dark:text-secondary-400">
          This page is coming soon. We&apos;re working hard to bring you this feature.
        </p>
      </div>
    </div>
  );
}
